import environment from "Configs/environment";
import { useApp } from "Providers/AppProvider";
import { Project } from "domain-entities";
import { useAuthUser } from "Components/Auth/hooks/useAuthUser";

export function useRedirect() {
	const { isStandaloneApp } = useApp();

	return (path: string, isInNewTab?: boolean) => {
		const url = isStandaloneApp
			? `${environment.mainAppUrl}/${path}`
			: `/${path}`;

		if (isInNewTab) {
			void window.open(url, "_blank")?.focus();
		} else {
			window.location.href = url;
		}
	};
}

export function useRedirectToProject(projects: Project[]) {
	const userId = useAuthUser((state) => state.user?.uid);
	const { isNative } = useApp();
	const redirect = useRedirect();

	return (projectId: string) => {
		if (userId) {
			if (isNative && environment.deeplink) {
				window.location.href = `${environment.deeplink}projects/${projectId}`;
			} else {
				const project = projects.find((item) => item.id === projectId);

				if (project?.membersLastOpened?.[userId]) {
					redirect(`projects/${projectId}`, true);
				} else if (project?.membersLastOpenedArchived?.[userId]) {
					redirect(`archive/${projectId}`, true);
				}
			}
		}
	};
}
